export default "__VITE_ASSET__BQVM15_l__"